export default {
  'lang.english': 'English',
  'lang.hindi': 'Hindi',
  'lang.telugu': 'Telugu',

  'nav.master': 'Dashboard',
  'nav.dashboard': 'Overview',
  'nav.customers': 'Customers',
  'nav.finance': 'Finance',
  'nav.loans': 'Hand loans',
  'nav.accounts': 'Accounts',
  'nav.report': 'Reports',
  'nav.audit': 'Audit logs',
  'nav.erp': 'Finance ERP',
  'nav.consultancy': 'Consultancy',
  'nav.expenses': 'Expenses',
  'nav.employees': 'Employees & Payroll',
  'nav.settings': 'Settings',
  'nav.home': 'Home',
  'nav.clients': 'Clients',
  'nav.financeShort': 'Finance',
  'nav.loansShort': 'Loans',
  'nav.clientsShort': 'Clients',
  'nav.settingsShort': 'Settings',
  'nav.workspace': 'Workspace',
  'nav.collections': 'Collections',
  'nav.support': 'Support',
  'nav.contact': 'Contact',
  'nav.businessHours': 'Business hours desk',
  'nav.billingCollections': 'Billing & collections',

  'common.save': 'Save',
  'common.saved': 'Saved',
  'common.cancel': 'Cancel',
  'common.export': 'Export',
  'common.exportFile': 'Export File',
  'common.search': 'Search',
  'common.searchWorkspace': 'Search workspace…',
  'common.back': 'Back',
  'common.profile': 'Profile',
  'common.actions': 'Actions',
  'common.entryDate': 'Entry date',
  'common.logout': 'Log out',
  'common.borrower': 'Borrower',
  'common.facilities': 'Facilities',
  'common.principal': 'Principal',
  'common.collected': 'Collected',
  'common.outstanding': 'Outstanding',
  'payment.howWePaid': 'How we paid (disbursement)',
  'payment.howTheyPaid': 'How they paid (collection)',
  'payment.via': 'Payment via',
  'payment.cash': 'Cash',
  'payment.online': 'Bank',
  'payment.split': 'Cash + Bank',
  'payment.cashAmount': 'Cash amount (₹)',
  'payment.bankAmount': 'Bank amount (₹)',
  'payment.splitTotalHint': 'Cash + bank = ₹{sum} (must equal ₹{total})',
  'payment.selectBank': 'Select company bank',
  'payment.paidBy': 'Paid by / reference',
  'payment.cashCollections': 'Cash collections',
  'payment.bankCollections': 'Bank collections',
  'payment.cashDisbursements': 'Cash disbursements',
  'payment.bankDisbursements': 'Bank disbursements',
  'payment.cashTaken': 'Cash taken',
  'payment.cashGiven': 'Cash given',
  'payment.accountCredited': 'Bank credit',
  'payment.accountDebited': 'Bank debit',
  'payment.collectionsIn': 'Collections in',
  'payment.loanDisbursed': 'Loan given',
  'payment.addBankInSettings': 'Add company bank accounts in Settings → Banks for online tracking.',
  'payment.selectBankRequired': 'Select a bank for online payment',
  'payment.paidByRequired': 'Enter who paid or transaction reference',
  'payment.selectVia': 'Select payment method',
  'payment.chooseBank': 'Choose bank account',
  'payment.paidByPlaceholder': 'Customer name, UTR, cheque no., or notes',
  'payment.cashPaidByPlaceholder': 'Optional — who collected or receipt note',
  'common.nextDue': 'Next due',
  'common.amount': 'Amount',
  'common.noMatch': 'No customers match',
  'common.appliesWorkspace': 'applies to this workspace only',
  'common.add': 'Add',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.new': 'New',
  'common.close': 'Close',
  'common.submit': 'Submit',
  'common.confirm': 'Confirm',
  'common.loading': 'Loading…',
  'common.status': 'Status',
  'common.date': 'Date',
  'common.phone': 'Phone',
  'common.email': 'Email',
  'common.name': 'Name',
  'common.total': 'Total',
  'common.view': 'View',
  'common.filter': 'Filter',
  'common.sort': 'Sort',
  'common.all': 'All',
  'common.select': 'Select',
  'common.selectLoan': 'Select loan',
  'common.swipeTable': 'Swipe the table left or right for more columns',
  'common.readOnly': 'Read-only access',
  'common.finance': 'Finance',
  'common.handLoans': 'Hand loans',
  'common.line': 'Line',
  'common.customer': 'Customer',
  'common.created': 'Created',
  'common.updated': 'Updated',
  'common.records': 'records',
  'common.inPeriod': 'in period',

  'status.paid': 'Paid',
  'status.due': 'Due',
  'status.scheduled': 'Scheduled',
  'status.active': 'Active',
  'status.seized': 'Seized',
  'status.closed': 'Closed',
  'status.readyToClose': 'Ready to close',
  'status.disabled': 'Disabled',
  'status.default': 'Default',

  'login.signIn': 'Sign in',
  'login.signingIn': 'Signing in…',
  'login.emailPlaceholder': 'Email or mobile number',
  'login.password': 'Password',
  'login.showPassword': 'Show password',
  'login.hidePassword': 'Hide password',
  'login.welcome': 'Welcome back',
  'login.subtitle': 'Sign in to your workspace',
  'login.createAccount': 'Create account',
  'login.enterOtp': 'Enter OTP',
  'login.otpSubtitle': 'Go back and sign in with email + password.',
  'login.signUpSubtitle': 'Set up your organization workspace.',
  'login.or': 'or',
  'login.alreadyHaveAccount': 'Already have an account?',
  'login.newOrganization': 'New organization?',
  'login.register': 'Register',
  'login.verifyOtp': 'Verify OTP',

  'audit.title': 'Audit trail',
  'audit.subtitle': 'Immutable activity log',
  'audit.auditorMode': 'Auditor mode — read-only',
  'audit.disclaimer':
    'Management records from EdgeFinances data — not a statutory audit report.',
  'audit.statTotal': 'Total events',
  'audit.statToday': 'Today',
  'audit.statLogins': 'Sign in / out',
  'audit.statUpdates': 'Updates',
  'audit.statSecurity': 'Security',
  'audit.searchPlaceholder': 'Search user, loan, action, IP…',
  'audit.refresh': 'Refresh',
  'audit.actionFilter': 'Action type',
  'audit.tableTitle': 'Activity log',
  'audit.events': 'events',
  'audit.empty': 'No audit events yet',
  'audit.emptyHint': 'Actions will appear here as your team uses the workspace.',
  'audit.exportTitle': 'Audit trail export',
  'audit.detailTitle': 'Audit entry',
  'audit.actor': 'User',
  'audit.entity': 'Record',
  'audit.reason': 'Reason',
  'audit.device': 'Device',
  'audit.changes': 'Changes',
  'audit.oldValue': 'Old value',
  'audit.newValue': 'New value',
  'audit.action': 'Action',
  'audit.summary': 'Summary',
  'audit.prev': 'Previous',
  'audit.next': 'Next',

  'erp.title': 'Finance ERP',
  'erp.subtitle': 'Statements, journals & insights',
  'erp.tab.overview': 'Overview',
  'erp.tab.fy': 'Financial year',
  'erp.tab.trial': 'Trial balance',
  'erp.tab.balance': 'Balance sheet',
  'erp.tab.pl': 'P&L',
  'erp.tab.cashflow': 'Cash flow',
  'erp.tab.daybook': 'Day book',
  'erp.tab.ledger': 'Ledger book',
  'erp.tab.journal': 'Journal',
  'erp.tab.reconcile': 'Reconciliation',
  'erp.tab.auditreport': 'Audit report',
  'erp.businessScore': 'Business score',
  'erp.profitMargin': 'Profit margin',
  'erp.collectionPct': 'On-time %',
  'erp.outstandingPct': 'Outstanding %',
  'erp.aiAuditor': 'AI Auditor',
  'erp.aiSubtitle': 'Automated insights from your books',
  'erp.noInsights': 'No anomalies detected for this period.',
  'erp.recommendations': 'Recommendations',
  'erp.fySubtitle': 'Lock periods, carry forward opening balances',
  'erp.fyOpenStatus': 'Open',
  'erp.fyClosedStatus': 'Closed',
  'erp.closeFy': 'Close financial year',
  'erp.confirmCloseFy': 'Close this financial year? Entries will be locked and opening balances carried forward.',
  'erp.fyClosed': 'Financial year closed successfully',
  'erp.difference': 'Books vs cash-flow',
  'erp.needsVerification': 'Needs verification',
  'erp.reconcileHint':
    'Cash and bank balances can differ — that is normal. Difference here means journal books total does not match the cash-flow statement (collections, expenses, openings).',
  'erp.booksTotal': 'Books total (cash + bank)',
  'erp.flowTotal': 'Cash-flow closing',
  'erp.matched': 'Matched',
  'erp.assets': 'Assets',
  'erp.liabilitiesEquity': 'Liabilities & equity',
  'erp.netWorth': 'Net worth',
  'erp.income': 'Income',
  'erp.expenses': 'Expenses',
  'erp.netProfit': 'Net profit',
  'erp.openingCash': 'Opening cash',
  'erp.collections': 'Collections',
  'erp.otherIncome': 'Other income',
  'erp.salary': 'Salary',
  'erp.closingCash': 'Closing cash',
  'erp.closingTotal': 'Total cash + bank',
  'erp.cashBook': 'Cash book',
  'erp.bankBook': 'Bank book',
  'erp.reverse': 'Reverse',
  'erp.reverseReason': 'Reason for reversal (required for audit trail)',
  'erp.reversed': 'Reverse journal created',
  'erp.noData': 'No transactions in this period',
  'erp.auditReportSubtitle': 'One-click audit-ready package',
  'erp.auditReportHint': 'Export includes trial balance, balance sheet, P&L, cash flow, day book, and ledger summary. View full audit trail in Audit logs.',
  'erp.viewAuditLogs': 'Open audit logs',
} as const;
